export default __webpack_public_path__ + "static/media/logo.0cf4b1ab.svg";